import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {Button, Modal} from 'react-bootstrap';
import {Form, Formik} from 'formik';
import * as actions from '../../_redux/invoicesActions';
import can from '../../../_common/components/Permissions/can';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

const PopupSendMail = ({
                         invoiceTypeID,
                         invoiceNum,
                       }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const buttonClassName = `w-100 px-4 py-2 d-flex align-items-center justify-content-between text-nowrap font-size-lg 
  ${(can('full', 'invoices')) ? `` : `opacity-30`}`;
  const labelSendMail = intl.formatMessage({
    id: 'invoices-button-sendMail',
    defaultMessage: 'Send mail',
  });
  const headerSendEMail = intl.formatMessage({
    id: 'invoices-popup-header',
    defaultMessage: 'Send',
  });
  const cancelButton = intl.formatMessage({
    id: 'invoices-popup-buttonCancel',
    defaultMessage: 'Cancel',
  });
  const sendButton = intl.formatMessage({
    id: 'invoices-popup-buttonSend',
    defaultMessage: 'Send',
  });
  const validationMessage = intl.formatMessage({
    id: 'invoices-popup-validation',
    defaultMessage: 'Message',
  });

  const sendInvoicesByEmailFunc = ({invoiceTypeID, invoiceNum, emailAddress}) => () => {
    dispatch(actions.sendInvoicesByEmailAction({invoiceTypeID, invoiceNum, emailAddress}));
    setShow(false);
  };

  const validate = (values) => {
    const errors = {};
    if (!values.emailAddress) {
      errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailAddress)) {
      errors.email = 'Invalid email address';
    }

    return errors;
  };

  return (
    <>
      <div
        className={buttonClassName}
        onClick={() => {
          if (can('full', 'receipts')) {
            handleShowModal();
          }
        }}
      >
        {labelSendMail}
        <img
          src={toAbsoluteUrl('/media/svg/Outgoing-mail_brandColor.svg')}
          alt="icon"
          className={'w-30px h-30px ml-2'}
        />
      </div>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <Formik
            validate={validate}
            initialValues={{emailAddress: ''}}
            onSubmit={() => {}}
            enableReinitialize={true}
            validateOnChange={true}
            validateOnBlur={false}
          >
            {({
                values,
                handleBlur,
                setFieldValue,
                errors,
              }) => (
              <Form className="form form-label-right">
                <div className={styles.invoicesSendMail}>
                  <h3 className="card-title font-weight-bold text-dark">
                    {headerSendEMail}
                  </h3>
                  <div className="mb-12 w-75 d-flex flex-column align-items-center position-relative">
                    <input
                      type="text"
                      className="form-control custom-data-item"
                      name="emailAddress"
                      value={values.emailAddress}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue('emailAddress', e.target.value);
                      }}
                    />
                    {(errors.email) &&
                      <div className="text-danger mr-40 mt-6 font-size-sm position-absolute top-10">
                        {validationMessage}
                      </div>
                    }
                  </div>
                  <div className="d-flex w-50 justify-content-center">
                    <Button
                      className="btn-secondary btn-sm col-6 mx-3"
                      onClick={handleCloseModal}
                    >
                      {cancelButton}
                    </Button>
                    <Button
                      type="submit"
                      className="btn-sm col-6 mx-3 custom-send-button"
                      onClick={(!errors.email && values.emailAddress) &&
                        sendInvoicesByEmailFunc({
                          invoiceTypeID: invoiceTypeID,
                          invoiceNum: invoiceNum,
                          emailAddress: values.emailAddress
                        })
                      }
                    >
                      {sendButton}
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupSendMail;
